import getMeta from '@atlassian/jira-get-meta';
import { isComingFromSyntheticTest } from '../../feature-flags';

export const isSynthetic = () =>
	// Filter out synthetic tests using all known ways
	getMeta('ajs-is-synthetic') === 'true' || isComingFromSyntheticTest();
